<app-navbar-style-two></app-navbar-style-two>

<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Solutions Details</h2>
            <ul>
                <li><a routerLink="/"><i class="bx bx-home"></i> Home</a></li>
                <li class="active">Solutions Details</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Solution Details Area -->
<section class="solutions-details-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="solutions-content">
                    <h3>Our cyber security solutions</h3>
                    <p>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie conse quat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.</p>
                    <p>Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.</p>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="solutions-details-one">
                    <img src="assets/img/solution-details/solution-details-1.jpg" alt="Image">
                </div>
            </div>

            <div class="col-lg-12 col-md-12">
                <div class="solutions-content two">
                    <h3>Waza is changinga the world of cybersecurity</h3>
                    <p>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.</p>
                    <p>Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.</p>
                </div>
            </div>

            <div class="col-lg-12 col-md-12">
                <div class="solutions-content three">
                    <h3>Solutions for everyone</h3>
                    <p>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.</p>
                </div>
            </div>

            <div class="col-lg-12 col-md-12">
                <div class="solutions-content four">
                    <h3>Security challenge</h3>
                    <p>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.</p>
                    <ul>
                        <li><i class="bx bx-check-circle"></i> Identifying threats</li>
                        <li><i class="bx bx-check-circle"></i> Mitigating cyber security risk</li>
                        <li><i class="bx bx-check-circle"></i> Protecting malware</li>
                        <li><i class="bx bx-check-circle"></i> Defending insider threats</li>
                        <li><i class="bx bx-check-circle"></i> Securing remote workers</li>
                        <li><i class="bx bx-check-circle"></i> Testing cyber security</li>
                    </ul>
                    <div class="challenge-btn">
                        <a routerLink="/contact" class="default-btn overly-one"><span>Talk to expert</span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Solution Details Area -->